import { isAuthenticated } from '../common/permissions';
import { Dashboard } from './Dashboard';

export default [
  {
    exact: true,
    path: '/home',
    helpId: 'dashboard',
    permissions: [isAuthenticated],
    component: Dashboard,
  },
];
